window.formatMoney = function(cents) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  // Use Shopify's built-in money formatter
  if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
    return Shopify.formatMoney(cents, Shopify.money_format);
  }
  // Fallback
  return (cents / 100).toFixed(2);
};

// Initialize only once
if (!window.buyTheLookInitialized) {
  window.buyTheLookInitialized = true;

  function initBuyTheLook() {
    // Tabs
    document.querySelectorAll('.buy-the-look').forEach(wrapper => {
      const tabs = wrapper.querySelectorAll('.pair-product-tab');
      const contents = wrapper.querySelectorAll('.pair-product-content');

      const activateTab = (handle) => {
        tabs.forEach(tab => tab.classList.remove('active'));
        contents.forEach(content => content.classList.remove('active'));
        wrapper.querySelector(`.pair-product-tab[data-handle="${handle}"]`)?.classList.add('active');
        wrapper.querySelector(`#pair-${handle}`)?.classList.add('active');
      };

      tabs.forEach(tab => tab.addEventListener('click', () => activateTab(tab.dataset.handle)));

      if (tabs.length > 0) activateTab(tabs[0].dataset.handle);
    });

    // Multi-variant
    document.querySelectorAll('.pair-variant-swatches').forEach(wrapper => {
      const product = JSON.parse(wrapper.dataset.productJson);
      const optionNames = wrapper.dataset.optionNames.split('|');
      const form = wrapper.querySelector('.pair-add-form');
      const idInput = form.querySelector('[name="id"]');
      const errorEl = wrapper.querySelector('.pair-variant-error');
      const addBtn = wrapper.querySelector('.pair-btn-add');
      const qtyInput = wrapper.querySelector('.pair-qty-input');
      const minus = wrapper.querySelector('.pair-qty-btn.minus');
      const plus = wrapper.querySelector('.pair-qty-btn.plus');

      const priceSale = wrapper.closest('.pair-product-reference-content').querySelector('.price-sale');
      const priceCompare = wrapper.closest('.pair-product-reference-content').querySelector('.price-compare');
      const pricePercentage = wrapper.closest('.pair-product-reference-content').querySelector('.price-percentage');

      minus?.addEventListener('click', () => { if (parseInt(qtyInput.value) > 1) qtyInput.value--; });
      plus?.addEventListener('click', () => qtyInput.value++);

      const updateVariant = () => {
        // let selected = [];
        // for (let i = 1; i <= product.options.length; i++) {
        //   const input = wrapper.querySelector(`input[name="option-${product.id}-${i}"]:checked`);
        //   if (!input) {
        //     errorEl.textContent = `Please select ${optionNames[i-1] || 'an option'}`;
        //     errorEl.classList.add('has-error');
        //     addBtn.disabled = true;
        //     return;
        //   }
        //   selected.push(input.value);
        // }
let selected = [];

for (let i = 1; i <= product.options.length; i++) {
  const select = wrapper.querySelector(`select[name="option-${product.id}-${i}"]`);

  if (!select || !select.value) {
    errorEl.textContent = `Please select ${optionNames[i - 1] || 'an option'}`;
    errorEl.classList.add('has-error');
    addBtn.disabled = true;
    return;
  }

  selected.push(select.value);
}
        const variant = product.variants.find(v => v.options.every((o, idx) => o === selected[idx]));

        if (variant) {
          idInput.value = variant.id;
          errorEl.textContent = '';
          errorEl.classList.remove('has-error');
          addBtn.disabled = !variant.available;

          if (!variant.available) {
            errorEl.textContent = 'Sold out';
            errorEl.classList.add('has-error');
          }

          // Price formatting using Shopify.formatMoney
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            priceSale.textContent = formatMoney(variant.price);
            priceCompare.textContent = formatMoney(variant.compare_at_price);
            const percent = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
            pricePercentage.textContent = `${percent}% OFF`;
          } else {
            priceSale.textContent = formatMoney(variant.price);
            priceCompare.textContent = '';
            pricePercentage.textContent = '';
          }
        } else {
          errorEl.textContent = 'Unavailable combination';
          errorEl.classList.add('has-error');
          addBtn.disabled = true;
          priceSale.textContent = priceCompare.textContent = pricePercentage.textContent = '';
        }
      };

    //   wrapper.querySelectorAll('input[type="radio"]').forEach(r => r.addEventListener('change', updateVariant));
        wrapper.querySelectorAll('select').forEach(select =>
            select.addEventListener('change', updateVariant)
        );
      updateVariant();

      // Add to cart
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        if (!idInput.value || parseInt(qtyInput.value) < 1) return;

        addBtn.disabled = true;
        addBtn.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
        .then(r => r.json())
        .then(data => {
          if (data.status === 422 || data.status === 400) {
            errorEl.textContent = data.message || 'Error';
            errorEl.classList.add('has-error');
          } else {
            errorEl.textContent = '';
            errorEl.classList.remove('has-error');
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
            document.dispatchEvent(new CustomEvent('cart:reload', { bubbles: true }));
            setTimeout(() => document.querySelector('hdt-cart-drawer')?.open(), 800);
          }
        })
        .catch(() => {
          errorEl.textContent = 'Error adding to cart';
          errorEl.classList.add('has-error');
        })
        .finally(() => {
          addBtn.disabled = false;
          addBtn.textContent = 'ADD TO BAG';
        });
      });
    });

    // Single variant - Same cart logic
    document.querySelectorAll('.pair-single-variant .pair-add-form').forEach(form => {
      const errorEl = form.querySelector('.pair-variant-error');
      const addBtn = form.querySelector('.pair-btn-add');
      const qtyInput = form.querySelector('.pair-qty-input');
      const minus = form.querySelector('.pair-qty-btn.minus');
      const plus = form.querySelector('.pair-qty-btn.plus');

      minus?.addEventListener('click', () => { if (parseInt(qtyInput.value) > 1) qtyInput.value--; });
      plus?.addEventListener('click', () => qtyInput.value++);

      form.addEventListener('submit', function(e) {
        e.preventDefault();
        if (parseInt(qtyInput.value) < 1) return;

        addBtn.disabled = true;
        addBtn.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
        .then(r => r.json())
        .then(data => {
          if (data.status === 422 || data.status === 400) {
            errorEl.textContent = data.message || 'Error';
            errorEl.classList.add('has-error');
          } else {
            errorEl.textContent = '';
            errorEl.classList.remove('has-error');
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
            document.dispatchEvent(new CustomEvent('cart:reload', { bubbles: true }));
            setTimeout(() => document.querySelector('hdt-cart-drawer')?.open(), 800);
          }
        })
        .catch(() => {
          errorEl.textContent = 'Error adding to cart';
          errorEl.classList.add('has-error');
        })
        .finally(() => {
          addBtn.disabled = false;
          addBtn.textContent = 'ADD TO BAG';
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBuyTheLook);
  } else {
    initBuyTheLook();
  }
}